import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './theme/header/header.component';
import { FooterComponent } from './theme/footer/footer.component';
import { ErrorMessageComponent } from './theme/error-message/error-message.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { JobFilterComponent } from './shared/job-filter/job-filter.component';
import { FilterListComponent } from './shared/filter-list/filter-list.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { PaginationComponent } from './shared/pagination/pagination.component';
import { TruncatePipe } from './pipes/truncate/truncate.pipe';
import { SpecialCharacterDirective } from './directives/special-chars/special-character.directive';
import { UpperCaseDirective } from './directives/upper-case.directive';
import { SafeHtmlPipe } from './pipes/safeHtml/safe-html.pipe';
import { FormatDatePipe } from './pipes/format-date.pipe';
import { AppsPipePipe } from './pipes/apps-pipe.pipe';
import { ReasonPipe } from './pipes/reason.pipe';
import { CaptchaComponent } from './shared/captcha/captcha.component';
import { PasswordValidationComponent } from './shared/password-validation/password-validation.component';
import { ValidationService } from './services/validation.service';


// import { ScrollSpyDirective } from 'src/app/directives/scroll-spy.directive';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgSelectModule,
    ToastrModule.forRoot(),
  ],
  declarations: [
    HeaderComponent,
    FooterComponent,
    // ScrollSpyDirective,
    SpecialCharacterDirective,
    UpperCaseDirective,
    JobFilterComponent,
    FilterListComponent,
    PaginationComponent,
    ErrorMessageComponent,
    CaptchaComponent,
    TruncatePipe,
    SafeHtmlPipe,
    FormatDatePipe,
    AppsPipePipe,
    ReasonPipe,
    PasswordValidationComponent
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    HeaderComponent,
    PaginationComponent,
    JobFilterComponent,
    FilterListComponent,
    FormsModule,
    ReactiveFormsModule,
    FooterComponent,
    ErrorMessageComponent,
    CaptchaComponent,
    ToastrModule,
    TruncatePipe,
    SafeHtmlPipe,
    FormatDatePipe,
    SpecialCharacterDirective,
    UpperCaseDirective,
    AppsPipePipe,
    ReasonPipe,
    PasswordValidationComponent
  ],providers:[ValidationService]
})
export class SharedModule { }
